import {useSyncExternalStore} from "react";
import {browserName, browserVersion, isMacOs, isMobile} from "react-device-detect";
import {
    getInstallPlatform,
    getVersion,
    hasDeferredPrompt,
    isStandalone,
    promptInstall,
    readInstallRecord,
    recordDismiss,
    shouldOfferInstall,
    subscribe,
} from "./installState";
import {getActiveManifestBrand} from "./manifest";

/**
 * canOffer: whether to raise the install offer on our own, honouring the cooldown.
 * available: whether install is possible at all, for an entry point the client opens on purpose.
 */
const useInstallPrompt = () => {
    // re-render on every change to the prompt or the stored record
    useSyncExternalStore(subscribe, getVersion);

    const brand = getActiveManifestBrand();
    const platform = getInstallPlatform({
        hasManifest: !!brand,
        hasPrompt: hasDeferredPrompt(),
        browserName,
        browserVersion,
        isMacOs,
        isMobile,
    });
    const standalone = isStandalone();
    const record = readInstallRecord();

    return {
        brand,
        platform,
        available: platform !== "unsupported" && !standalone,
        canOffer: shouldOfferInstall({platform, standalone, record}),
        promptInstall,
        dismiss: () => recordDismiss(),
    };
};

export default useInstallPrompt;
